import { render, staticRenderFns } from "./CalendarEditRestrictionsForm.vue?vue&type=template&id=5991d3d6&scoped=true&"
import script from "./CalendarEditRestrictionsForm.vue?vue&type=script&lang=js&"
export * from "./CalendarEditRestrictionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5991d3d6",
  null
  
)

export default component.exports